import { useEffect, useRef } from "react";
import { useQuery } from "@apollo/client/react";
import { SystemSettingsDocument } from "@/graphql/generated/operations";
import { isTobisDetached } from "@/lib/tobis-mode";
import { useThemePrefs } from "@/stores/theme-prefs";

// Hydrate the live theme palette from systemSettings (server, platform-wide).
// Runs once when the settings load; server values win over local theme-prefs so
// the brand palette is consistent for everyone (incl. non-admins who cannot
// open the settings). Empty/null fields are ignored, falling back to the local
// palette / defaults. Without genesis (tobis detached) the local palette stays.
export function useHydrateThemeFromSystemSettings(): void {
  const { data } = useQuery(SystemSettingsDocument, { skip: isTobisDetached() });
  const settings = data?.systemSettings;
  const done = useRef(false);

  useEffect(() => {
    if (done.current || !settings) return;
    done.current = true;
    const store = useThemePrefs.getState();
    if (settings.backgroundColor) store.setBgColor(settings.backgroundColor);
    if (settings.surfaceColor) store.setSurfaceColor(settings.surfaceColor);
    if (settings.accentColor) store.setAccentColor(settings.accentColor);
  }, [settings]);
}
